export const USER_PILOT_SECTION_ID = 'automation-editor';
